import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getCannotReopenUnsyncedTabDialog } from '../Selectors'
import ConfirmModalV2 from '../../components/ConfirmModalV2'
import { APPLICATION_STRINGS } from '../../strings'
import { setCannotReopenUnsyncedTabDialog } from '../ActionCreators'
import { setRoute } from '../../VNRoutes/ActionCreators'
import useSpinner from '../../context/hooks/useSpinner'

export const VNCannotReopenUnsyncedTab = () => {
  const dispatch = useDispatch()
  const open = useSelector((state) => getCannotReopenUnsyncedTabDialog(state))
  const { startSpinner, stopSpinner } = useSpinner()

  const goToDeviceSummary = () => {
    startSpinner()
    dispatch(setRoute('/orders/device-summary'))
    dispatch(setCannotReopenUnsyncedTabDialog({ open: false }))
    //using setTimeout to use the spinner as transition after closing the modal
    setTimeout(() => stopSpinner(), 1000)
  }

  if (!open) {
    return null
  }

  return (
    <ConfirmModalV2
      onButtonOneClick={() => dispatch(setCannotReopenUnsyncedTabDialog({ open: false }))}
      onButtonTwoClick={() => goToDeviceSummary()}
      headerText={APPLICATION_STRINGS.CANNOT_REOPEN_TAB}
      subtext={APPLICATION_STRINGS.CANNOT_REOPEN_UNSYNCED_TAB}
      buttonOneText={APPLICATION_STRINGS.OKAY_BUTTON_TEXT}
      buttonTwoText={APPLICATION_STRINGS.SYNC_NOW_BUTTON_TEXT}
    />
  )
}
